import axios from 'axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import { performLogout } from '@studio/storeV2/authentication/helpers/perform-logout';
import * as SessionStore from '@studio/storeV2/authentication/session-store';
import type { Authentication } from '@studio/types';

const tokenUrl = `${CENTRAL_API_V3}/auth/token`;

async function refreshAuthToken(): Promise<string> {
  try {
    const response = await axios.post<Authentication.Post.Token>(
      tokenUrl,
      { grant_type: 'refresh_token_cookie' },
      { withCredentials: true }
    );
    SessionStore.session.setAccessToken(response.data.access_token);
    SessionStore.session.setAccessTokenTimestamp(Date.now());

    return response.data.access_token;
  } catch (error) {
    await performLogout({
      onFinally: () => {
        SessionStore.session.setTokenExpired();
      },
    });
    return Promise.reject(error);
  }
}

export { refreshAuthToken };
